import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation }  from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import img1 from "../../assets/gal3.jpg";
import img2 from "../../assets/gal4.jpg";
import img3 from "../../assets/gal7.jpg";
import img4 from "../../assets/gal9.jpg";

import { Link } from 'react-router-dom';

const Featured = () => {
  // const dispatch = useDispatch();
  // const { t } = useTranslation();
  // const { featured, loading } = useSelector((state) => state.homeSlicer);
  // const lan = useSelector((state) => state.LanSlicer.language);

  // useEffect(() => {
  //   const promise = dispatch(getFeatured(lan));
  //   return () => {
  //     promise.abort();
  //   };
  // }, [lan, dispatch]);

  
  
    return (
      <section className="section-wrap">
      <div className="container">
        <div className="row row-10">
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img1} alt=""/>
              <div className="overlay">
                <h2 className="uppercase cat-title">Camera</h2>
              </div>
            </Link>
          </div>
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img2} alt=""/>
              <div className="overlay">
                <h2 className="uppercase cat-title">Laptop</h2>
              </div>
            </Link>
          </div>
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img3} alt=""/>
              <div className="overlay">
                <h2 className="uppercase cat-title">fire Alarm</h2>
              </div>
            </Link>
          </div>
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img4} alt=""/>
              <div className="overlay">
                <h2 className="uppercase cat-title">Systems</h2>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
    );
  };
  
  export default Featured;
  
